import React, {Component} from 'react'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import ReactLoading from 'react-loading'

var classNames = require('classnames')

class Overlay extends Component {

    render() {
        var classes = classNames('overlay', {overlay__active: this.props.overlayStatus})
        return (
            <div className={classes}>
                <ReactLoading type={'spin'} color={'blue'} />
            </div>
        )
    }

}

function mapStateToProps(state) {
    return {
        overlayStatus: state.overlayStatus
    }
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators({
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(Overlay)



 
